<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
/**
 * Basic-table component
 */
export default {
  components: { ErrorMessage,Layout, PageHeader },
  data() {
    return {
      title: "Sales Manager List",
      items: [
        {
          text: "Sales Manager",
          href: "/",
        },
        {
          text: "Sales Manager List",
          active: true,
        },
      ],
      salesmanagers: [],
      agents: {},
      admins: {},
        errors:null,
        visible:false,
        message:"",
    };
  },
  mounted() {
    this.getmanagerListList();
    this.getAgentList();
    this.getAdminList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    async getAgentList() {
      try {
        axios
          .get("/api/agent/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              var that = this;
              response.data.data.map(function (value, key) {
                that.$set(
                  that.agents,
                  value.users[0].id,
                  value.first_name + " " + value.last_name
                );
              });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getAdminList() {
      try {
        axios
          .get("/api/admin/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              var that = this;
              response.data.data.map(function (value, key) {
                that.$set(
                  that.admins,
                  value.id,
                  value.first_name + " " + value.last_name
                );
              });
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async getmanagerListList() {
      try {
        axios
          .get("/api/sales_manager/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
              this.salesmanagers = response.data.data;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    async deleteWarning(salesmanager) {
      var _this = this;
      try {
        this.$swal({
          title: "Are you sure?",
          text: "You can't revert your action",
          type: "error",
          showCancelButton: true,
          confirmButtonText: "Yes, Delete it!",
          cancelButtonText: "No",
          showCloseButton: true,
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.value) {
            _this.deleteItem(salesmanager);
          } else {
            this.$swal("Cancelled", "", "info");
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    deleteItem: function deleteItem(salesmanager) {
      var _this = this;
      axios
        .post("/api/sales_manager/delete/" + salesmanager.id, {
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then(function (response) {
          if(response.data.status){
              _this.$swal.fire({
                  position: 'top-end',
                  icon: 'error',
                  title: 'Successfully Remove Sales Manager From Customer',
                  showConfirmButton: false,
                  timer: 1000
              });
              _this.getAgentList();
              _this.hasDeleted = false;
              _this.getmanagerListList();
              _this.hasDeleted = false;
          } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              _this.errorCheck(jsonParse);
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="table-responsive table-responsive-sm">
              <table class="table mb-0 table-striped">
                <thead>
                  <tr>
                    <th>SL</th>
                    <th>Manager</th>
                    <th>Customer</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(salesmanager,index) in salesmanagers" v-bind:key="index">
                    <th scope="row">{{index+1}}</th>
                    <td>{{admins[salesmanager.manager_user_id]}}</td>
                    <td>{{agents[salesmanager.customer_user_id]}}</td>
                    <td><router-link :to="{ name: 'sales_manager_update', params: {id: salesmanager.id } }" class="btn btn-primary btn-small"><i class="fas fa-edit"></i> Edit</router-link> <button @click.prevent="deleteWarning(salesmanager)" class="btn btn-danger btn-small"><i class="fa fa-trash"></i> Delete</button></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
